import * as moment from 'moment';

import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { dateStringFromISO8601, propExists } from '../../../../../../../../../../utils';
import { CustomerMembership } from '../../../../../../../../../../models/membership';
import { CustomerMembershipStatus } from '../../../../../../../../../../models/membership-enums';

@Component({
  selector: 'app-edit-prepaid-customer-membership-days-remaining',
  templateUrl: './edit-prepaid-customer-membership-days-remaining.component.html',
  styleUrls: ['./edit-prepaid-customer-membership-days-remaining.component.css']
})
export class EditPrepaidCustomerMembershipDaysRemainingComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public newDaysRemaining: number;
  public oldDaysRemaining: number;

  public errorMessage = '';

  public dateStringFromISO8601 = dateStringFromISO8601;
  public CustomerMembershipStatus = CustomerMembershipStatus;

  private saveClickedSubscription: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    this.oldDaysRemaining = this.membership.days_remaining;
    this.newDaysRemaining = this.oldDaysRemaining;
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  public endDateAfterChange() {
    if (!propExists(this.newDaysRemaining)) { return ''; }

    return moment(this.membership.end_date)
      .add(this.newDaysRemaining - this.oldDaysRemaining, 'days')
      .format('ll');
  }

  private handleSave() {
    this.loadingEvent.emit(true);

    this.customerService
      .editPrepaidMembershipNumberOfDaysRemaining(
        this.membership,
        this.newDaysRemaining
      )
      .then(() => {
        this.savedCallback('Membership edited successfully.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
